import { render, staticRenderFns } from "./QuotationSummaryComponent.vue?vue&type=template&id=1dbb769c"
import script from "./QuotationSummaryComponent.vue?vue&type=script&lang=js"
export * from "./QuotationSummaryComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports